import React, { useState, useEffect } from 'react';
import { Language } from '../types/language';

interface Props {
  label: string;
  description?: string;
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
  area: number;
  onAreaChange: (area: number) => void;
  areaLabel: string;
  language?: Language;
}

export function ServiceToggle({ 
  label, 
  description, 
  enabled, 
  onToggle, 
  area, 
  onAreaChange,
  areaLabel,
  language = 'en'
}: Props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const buttonLabels = language === 'fr' 
    ? { yes: enabled ? '✓' : 'Oui', no: 'Non' }
    : { yes: enabled ? '✓' : 'Yes', no: 'No' };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={`p-4 rounded-lg transition-all duration-200 ${
      enabled ? 'bg-blue-50' : 'bg-white'
    } ${!isMobile ? 'md:border md:border-gray-200' : ''}`}>
      <div className="flex items-center justify-between mb-2">
        <div className="flex-grow">
          <label className="text-sm font-medium text-gray-700">{label}</label>
          {description && (
            <p className="text-xs text-gray-500 mt-1">{description}</p>
          )}
        </div>
        <div className="flex items-center ml-4">
          <button
            onClick={() => onToggle(true)}
            className={`px-3 py-1.5 text-sm rounded-l-md border transition-colors ${
              enabled ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            }`}
          >
            {buttonLabels.yes}
          </button>
          <button
            onClick={() => onToggle(false)}
            className={`px-3 py-1.5 text-sm rounded-r-md border-t border-b border-r transition-colors ${
              !enabled ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            }`}
          >
            {buttonLabels.no}
          </button>
        </div>
      </div>
      {enabled && (
        <div className="mt-3">
          <div className="relative">
            <input
              type="number"
              value={area || ''}
              onChange={(e) => onAreaChange(parseFloat(e.target.value) || 0)}
              className="w-full px-3 py-2 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder={areaLabel}
              min="0"
              step="0.01"
            />
          </div>
        </div>
      )}
    </div>
  );
}